<template>
    <div class="custom-checkbox">
        <the-btn
            text="Zaznacz wszystkie"
            class="btn-outline-custom d-none d-sm-inline-flex"
            :class="{ 'd-inline-flex': !selectAllData }"
            icon="CheckCorrect"
            @click.native="$emit('select', true)"
        />
        <the-btn
            text="Odznacz wszystkie"
            class="btn-danger ml-sm-2 d-none d-sm-inline-flex"
            :class="{ 'd-inline-flex': selectAllData }"
            icon="CheckIncorrect"
            @click.native="$emit('select', false)"
        />
    </div>
</template>

<script>
export default {
    props: {
        selectAllData: {
            type: Boolean,
            required: true
        }
    }
}
</script>
